import {Drawer, Stack, TextField, Typography} from "@mui/material";
import React from "react";
import {Industry, uni, updateIndustryUnits} from "../../firebase/index.js";
import APXActionButtons from "../../reusables/APXActionButtons.jsx";
import type {BSLProps} from "../../reusables/js/APXBottomSheetLayoutUtils.js";
import useBottomSheet from "../../reusables/js/APXBottomSheetLayoutUtils.js";


export default function AddNewUnitBSL({uid, onClose, i}: { i: Industry } & BSLProps) {
	  
	  const industry: Industry = i;
	  
	  const {isOpen, handleClose} = useBottomSheet({initialState: true, onClose});
	  
	  const [disablePositiveByDefault, setDisablePositiveByDefault] = React.useState(true);
	  
	  const [unitName, setUnitName] = React.useState("");
	  
	  React.useEffect(() => {
			 setDisablePositiveByDefault(/*FALSY->*/ !!!unitName.trim() || Object.values(industry.industryUnits).includes(unitName.trim()));
	  }, [unitName]);
	  
	  const handleCancel = () => {
			 setUnitName("");
			 onClose();
	  };
	  
	  const handleAdd = () => {
			 const vacantPosition = Object.entries(industry.industryUnits).find((kv) => /*FALSY->*/ !!!kv[1]);
			 if (/*TRUTHY->*/ !!vacantPosition) {
					const updatedIndustry: Industry = {...industry};
					updatedIndustry.industryUnits[vacantPosition[0]] = unitName.trim();
					updateIndustryUnits(uid, updatedIndustry.industryKey, updatedIndustry.industryUnits, () => {
						  alert("Unit added. Please refresh to see the change all throughout the app.");
					});
			 }
			 handleCancel();
	  };
	  
	  return (
				 <Drawer anchor="bottom" open={isOpen} onClose={handleClose} variant="temporary">
						<Stack spacing={2} p={2}>
							  <Stack direction={{xs: "column", sm: "row"}} spacing={2}>
									 {Object.values(industry.industryUnits).every((unit) => /*TRUTHY->*/ !!unit) ?
												<TextField label={`All ${uni}s Filled`} variant="outlined" fullWidth disabled/>
												:
												<TextField label={`${uni} Name`} variant="outlined" fullWidth required
															  value={unitName}
															  onChange={(e) => setUnitName(e.target.value)}
												/>
									 }
							  </Stack>
							  <Typography variant="body2" color="primary" align={"center"}>
									 {`Existing ${uni}s: `}{Object.values(industry.industryUnits).reduce((acc, unit) => acc + unit + " ", "")}
							  </Typography>
							  
							  
							  <APXActionButtons onCancel={handleCancel}
													  onAdd={handleAdd}
													  disablePositiveByDefault={disablePositiveByDefault}
													  shouldShowConfirmationDialog={true}
							  />
						</Stack>
				 </Drawer>
	  );
}
